// extracted by mini-css-extract-plugin
export var button = "_bi-7";
export var buttonRow = "_bi-6";
export var fadeIn = "_bi-1";
export var gradient = "_bi-0";
export var panel = "_bi-2";
export var panelIn = "_bi-3";
export var subtitle = "_bi-5";
export var title = "_bi-4";